import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpContextToken
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import Keycloak from 'keycloak-js';
import { Observable, from } from "rxjs";
import { switchMap } from 'rxjs/operators';
import { USER_MGMT_CNST } from "../../constants/proj.cnst";
import { AuthenticationService } from "../../modules/authentication/services/authentication.service";
import { AppStateService } from "../../services/app-state.service";
import { CsrfTokenService } from "../../services/csrf-token.service";
import { UtilsService } from "../../services/utils.service";
import { Router } from "@angular/router";
import { isNullOrUndefined } from "../../shared/common-utils";
import { APIMapping } from "../../shared/vl-http/api-mapping.cnst";
import { KeycloakService } from "../../services/keycloak.service";

// Create a context token to identify when to skip headers
export const SKIP_INTERCEPTOR = new HttpContextToken(() => false);
@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private authSrv: AuthenticationService,
    private csrfTokenSrv: CsrfTokenService,
    private utilSrv: UtilsService,
    private appStateSrv: AppStateService,
    // private  route: Router,
    private keyCloakSrv: KeycloakService
  ) {
    console.log("Auth Interceptor called constructor")
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //       const notIntercept =  request.url.includes('inncircles')
    // if (notIntercept) {
    //      // ✅ Add Authorization header specifically for GeoServer
    //     // if (request.url.includes('/geoserver/')) {
    //     //     console.log("Adding Authorization header for GeoServer request");

    //     //     request = request.clone({
    //     //       setHeaders: {
    //     //         Authorization: this.generateAuthHeader()}
    //     //     });

    //     // }

    //     return next.handle(request);
    //   }
    return from(this.fetchDetails(request)).pipe(
      switchMap((result: any) => {
        if (isNullOrUndefined(result)) {
          console.log("Auth Interceptor - No auth details needed for this request", request);

          return next.handle(request);
        }
        if (request.context.get(SKIP_INTERCEPTOR)) {
          return next.handle(request);
        }
        request = this.trialSpace(request);
        const csrfToken = this.csrfTokenSrv.getCsrfToken();
        const isCsrfGenerationUrl = request.url.includes(USER_MGMT_CNST.API_MAPPING.GET_CSRF_TOKEN);
        // const userMetaInfo = this.appStateSrv.getUserMetaInfo();
        const stateMeta = this.appStateSrv.getUserMetaInfo();
        const localMeta = JSON.parse(localStorage.getItem('metaInfo') || '{}');

        const userMetaInfo = stateMeta && Object.keys(stateMeta).length
          ? stateMeta
          : localMeta;


        const customerUuid = this.appStateSrv.getOrganizationInfo()?.customerId ?? userMetaInfo.customerId;

        // if (
        //   isNullOrUndefined(customerUuid) &&
        //   !request.url?.includes('auth') &&
        //   !(
        //     request?.url?.includes('um') && 
        //     !request.url?.includes('um/get-application')
        //   ) &&
        //   !['llm', 'usermgmt', 'chatbot-widget'].some(path => this.route?.url?.includes(path))
        // ) {

        //     let additionalHeaders: HttpHeaders = request.headers;
        //   let modifiedRequest = request.clone({ headers: additionalHeaders });

        //   return next.handle(modifiedRequest)
        // }


        if (request.url.includes('/geoserver/')) {


          let additionalHeaders: HttpHeaders = request.headers;
          let modifiedRequest = request.clone({ headers: additionalHeaders });

          const headersObj: { [key: string]: string } = {
            Authorization: this.generateAuthHeader()

          };
          additionalHeaders = this.setHeaders(additionalHeaders, headersObj);
          modifiedRequest = modifiedRequest.clone({ headers: additionalHeaders });
          return next.handle(modifiedRequest);


        }
        if (!isNullOrUndefined(result.currentUser) && result.currentUser["accessToken"]) {
          const isDownloadApi = request.url.includes('land_management/layers/download');
          let additionalHeaders: HttpHeaders = this.buildAdditionalHeaders(isCsrfGenerationUrl, result.currentUser, csrfToken, request, userMetaInfo, customerUuid);
          let modifiedRequest = request.clone({ headers: additionalHeaders });
          if (isDownloadApi) {
            modifiedRequest = modifiedRequest.clone({
              responseType: 'blob' as 'json'
            });
          }
          if (request.url.includes('/geoserver/')) {


            let additionalHeaders: HttpHeaders = request.headers;
            const headersObj: { [key: string]: string } = {
              Authorization: this.generateAuthHeader()

            };
            additionalHeaders = this.setHeaders(additionalHeaders, headersObj);
            modifiedRequest.clone({ headers: additionalHeaders });

          }
          if (USER_MGMT_CNST.DOMAINS_NEEDING_USER_ID.some(item => request.url.includes(item))) {
            modifiedRequest = modifiedRequest.clone({
              params: (request.params ? request.params : new HttpParams()).set(
                "email",
                `${result.currentUser["userId"]}`
              )
            });
          }

          return next.handle(modifiedRequest);
        } else {
          if (request.url.includes(APIMapping.ADD_ATTACHMENT_CHAT_UPLOAD)) {
            let additionalHeaders: HttpHeaders = request.headers;
            let chatDetails = JSON.parse(localStorage.getItem('chatDetails') || '');
            const headersObj: { [key: string]: string } = {
              'user-uuid': chatDetails?.userId,
              'customer-uuid': chatDetails?.customerId,
              'application-uuid': chatDetails?.appId
            };
            additionalHeaders = this.setHeaders(additionalHeaders, headersObj);
            let changedRequest = request.clone({ headers: additionalHeaders });
            return next.handle(changedRequest);
          } else {
            return next.handle(request);
          }
        }
      })
    );
  }

  //Modifies URL of HttpRequest to replace trialspace
  trialSpace(request: HttpRequest<any>) {
    let modifiedUrl = request.url;
    let trimmedUrl = modifiedUrl.trimEnd();
    let trailingWhitespaceLength = modifiedUrl.length - trimmedUrl.length;
    modifiedUrl = trimmedUrl + '%20'.repeat(trailingWhitespaceLength);
    return request.clone({ url: modifiedUrl });
  }

  buildAdditionalHeaders(isCsrfGenerationUrl: boolean, currentUser: any, csrfToken: string | null, request: any, userMetaInfo: any, customerUuid: string | null): HttpHeaders {
    let additionalHeaders: HttpHeaders = request.headers;
    csrfToken = isNullOrUndefined(csrfToken) ? localStorage.getItem('csrfToken') : csrfToken;

    if (isCsrfGenerationUrl) {
      additionalHeaders = new HttpHeaders({
        'Authorization': request.url.includes('lps_user_management/lps_user_summary') ? `Bearer ${localStorage.getItem('access_token1')}` : `Bearer ${currentUser["accessToken"]}`
      });
    } else if (!isNullOrUndefined(csrfToken) && request
      .url) {
      // const applicationId = this.appStateSrv.getApplicationInfo()?.applicationId ?? this.getApplicationIdOfFirstApplication();
      const applicationId = '336d3e11-38f2-4a96-8edb-8e8fb7e7ad74'
      const headersObj: any = {
        'Authorization': request.url.includes('lps_user_management/lps_user_summary') ? `Bearer ${localStorage.getItem('access_token1')}` : currentUser["accessToken"] ? `Bearer ${currentUser["accessToken"]}` : `Bearer ${localStorage.getItem('token')}`,
        'Csrf-Token': csrfToken as string,
        'ngrok-skip-browser-warning': 'true'
      };


      if (Object.entries(userMetaInfo).length !== 0) {
        headersObj['user-uuid'] = userMetaInfo.userId;
        if (customerUuid) {
          headersObj['customer-uuid'] = customerUuid;
        }

      }
      if (applicationId !== undefined && !request?.url?.includes('get_dimensions_dropdown')) {
        headersObj['application-uuid'] = applicationId;
      }

      additionalHeaders = this.setHeaders(additionalHeaders, headersObj);
    }

    return additionalHeaders;
  }

  private setHeaders(headers: HttpHeaders, headersObj: { [key: string]: string }): HttpHeaders {
    for (const [key, value] of Object.entries(headersObj)) {
      headers = headers.set(key, value);
    }
    return headers;
  }


  private loadUserInfo() {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      const userDetails = JSON.parse(userInfo);
      return {
        accessToken: localStorage.getItem('token'),
        // accessToken : this.keyCloakSrv.getToken(),
        userId: userDetails?.userId || null
      }
    }
    return null;
  }

  private generateAuthHeader(): string {


    return `Bearer ${localStorage.getItem('token')}`;
  }
  private fetchDetails(request: HttpRequest<any>): Promise<any> {
    // const keycloakInstance = this.appStateSrv.getKeyCloakInstance();
    const keycloakInstance = this.keyCloakSrv.getKeycloakInstance()

    const result: {
      currentUser: any,
      token: string | null
    } = {
      currentUser: null,
      token: null
    };

    return new Promise((resolve) => {
      (async () => {
        if (request.url.includes('social-login') || request.url.includes('csrf')) {
          resolve(null);
          return;
        }

        const isTokenRefreshed = await this.refreshTokenIfNeeded(keycloakInstance);

        const finalToken = this.determineFinalToken(isTokenRefreshed, keycloakInstance);

        result.currentUser = this.loadUserInfo();
        result.token = finalToken;

        resolve(result);
      })();
    });
  }

  private async refreshTokenIfNeeded(keycloakInstance: Keycloak): Promise<boolean | null> {
    if (isNullOrUndefined(keycloakInstance)) {
      return null;
    }
    return await this.checkForTokenExpiryAndRefresh(keycloakInstance);
  }

  private determineFinalToken(isTokenRefreshed: boolean | null, keycloakInstance: Keycloak): string | null {
    const existingToken = localStorage.getItem('token');

    // Always prefer the token from the instance if available, as it is the source of truth
    if (keycloakInstance && keycloakInstance.token) {
      return keycloakInstance.token;
    }

    if (isTokenRefreshed) {
      return keycloakInstance.token ?? null;
    }
    if (existingToken === 'null') {
      return JSON.parse(existingToken) ?? null;
    }
    return existingToken;
  }

  private checkForTokenExpiryAndRefresh(keycloak: Keycloak): Promise<boolean | null> {
    return new Promise((resolve) => {
      (async () => {
        if (keycloak) {
          if (this.keyCloakSrv.isRefreshTokenExpired()) {
            this.utilSrv.showToastMessage("Session expired", "error");
            setTimeout(() => {
              this.utilSrv.logout();
            }, 200);
            resolve(null);
            return;
          }

          keycloak.onAuthRefreshError = () => {
            this.utilSrv.showToastMessage("Session expired", "error");
            setTimeout(() => {
              this.utilSrv.logout();
            }, 200);
          };

          try {
            if (keycloak.authenticated) {
              await this.keyCloakSrv.getToken();
              resolve(true);
            } else {
              resolve(null);
            }
          } catch (error) {
            resolve(null);
          }
        } else {
          resolve(null);
        }
      })();
    });
  }

  private getApplicationIdOfFirstApplication() {
    const permissions = this.appStateSrv.getUserPermissions();
    const applicationNames = Object.keys(permissions ?? {});
    if (applicationNames.length > 0) {
      return permissions[applicationNames[0]]?.['applicationId'];
    } else {
      return null;
    }
  }
}
